<template>
  <v-card flat class="setup-subtab-content">
    <div>
      <div class="font-weight-bold">{{ $t('currency.selectedCurrency') }}</div>
      <p>
        {{ $t('currency.currencyUsedEverywhere') }}
      </p>


      <v-radio-group
          class="mt-5"
          v-model="currency"
      >
        <v-radio
            value="USD"
            :label="$t('currency.usDollars')"
            :disabled="isLoading"
            @click="openDialog"
        />
        <v-radio
            value="GBP"
            :label="$t('currency.ukPounds')"
            :disabled="isLoading"
            @click="openDialog"
        />
        <v-radio
            value="JPY"
            :label="$t('currency.japaneseYen')"
            :disabled="isLoading"
            @click="openDialog"
        />
      </v-radio-group>

      <p v-if="!!publisherCurrency">
        <strong>{{ $t('currency.importantLabel') }}</strong> {{ $t('currency.importantNote') }}

        <span class="ml-1" v-if="publisherPriceDataFileIsLive">{{ $t('currency.replaceCustomPricelist') }}</span>

      </p>

      <p v-if="publisherCurrency === 'JPY'">
        <strong>{{ $t('currency.noteLabel') }}</strong> {{ $t('currency.jpyNote') }}
      </p>

    </div>

    <v-dialog
        persistent
        v-model="dialogIsShowing"
        max-width="500"
    >
      <v-card>
        <v-card-title v-if="!!publisherCurrency">
          {{ $t('currency.changeCurrency') }}
        </v-card-title>
        <v-card-title v-if="!publisherCurrency">
          {{ $t('currency.selectCurrency') }}
        </v-card-title>
        <div class="pa-6">
          <div v-if="!publisherCurrency">
            {{ $t('currency.willSetCurrency', { currency }) }}
          </div>
          <div v-if="!!publisherCurrency">
            <p>
              {{ $t('currency.confirmChangeCurrency', { currency }) }}
            </p>

            <template v-if="!!publisherCurrency">
              <p>
                {{ $t('currency.noConversion') }}
              </p>
              <p>
                {{ $t('currency.updateCostsNote', { currency }) }}

                <span class="ml-1" v-if="publisherPriceDataFileIsLive">{{ $t('currency.replaceCustomPricelist') }}</span>

              </p>

            </template>
          </div>
        </div>
        <v-card-actions>
          <v-spacer/>
          <v-btn
              depressed
              :disabled="isLoading"
              @click="cancelDialog"
          >
            {{ $t('common.cancel') }}
          </v-btn>
          <v-btn
              depressed
              color="primary"
              :loading="isLoading"
              @click="setCurrency(currency)"
          >
            {{ $t('currency.changeTo', { currency }) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-card>


</template>


<script>
import _ from "lodash"
import {mapGetters, mapMutations, mapActions} from 'vuex'
import {api} from "@/api";


export default {
  name: "PublisherSetupTabWarnings",
  components: {},
  props: {},
  data() {
    return {
      isLoading: false,
      currency: "USD",
      dialogIsShowing: false,
      currencyValueBeforeDialog: null,
      currencyLastValue: null,
    }
  },
  methods: {
    cancelDialog() {
      this.currency = this.currencyLastValue
      this.dialogIsShowing = false
    },
    openDialog() {
      this.dialogIsShowing = true
    },

    async setCurrency(currency) {
      console.log("setCurrency()", currency)
      this.isLoading = true
      const path = `publisher/${this.publisherId}`
      const postData = {currency}
      try {
        await api.postFile(path, postData)
        await this.$store.dispatch("refreshPublisher")
        this.$store.commit("snackbar", this.$t('currency.currencyChanged', { currency }))
      } catch (e) {
        console.log("there was an error.")
      } finally {
        this.dialogIsShowing = false
        this.isLoading = false
      }
    }
  },
  computed: {
    ...mapGetters([
      "publisherId",
      "publisherWarnings",
      "publisherCurrency",
      "publisherPriceDataFileIsLive",
    ]),
  },
  created() {
  },
  mounted() {
    this.currency = this.publisherCurrency
  },
  watch: {
    currency: function (to, from) {
      this.currencyLastValue = from
    }
  }
}
</script>

<style lang="scss">


</style>
